import { PropsWithChildren, ReactNode } from 'react'
import SpinnerIcon from '../../../images/spinner.svg'

type Props = PropsWithChildren<{
  isLoading: boolean
  size?: number
}>

export default function ProcessingRingComponent({
  isLoading,
  size = 5,
  children
}: Props): ReactNode {
  if (!isLoading) {
    return children
  }

  return (
    <div className="relative">
      <div className={`absolute inset-1/2 ${children ? "-translate-y-1/2 -translate-x-1/2" : ""} z-10 h-${size} w-${size}`}>
        <SpinnerIcon className={`animate-spin text-primary h-${size} w-${size}`} />
      </div>
      <div className="opacity-50 pointer-events-none">{children}</div>
    </div>
    )
}
